import { AlertProps, TwoColumnLayout } from '@ui-components/neo.tax';

import { StyledAlertForCard } from './forms.styled';

export const FormAlertCard = (props: AlertProps): React.ReactElement => (
  <TwoColumnLayout>
    <StyledAlertForCard {...props} />
  </TwoColumnLayout>
);
